import { useEffect, useState } from "react";

// Delay flipping a boolean to `true` until it has stayed truthy for `delayMs`.
// Si vuelve a `false` antes del delay, no se activa. Sirve para evitar el
// "flash de loader" cuando una operación termina antes que el ojo lo registre
// (~200ms). Cuando el valor pasa a false, vuelve inmediatamente a false.
export function useDelayedFlag(value: boolean, delayMs = 200): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!value) {
      setDelayed(false);
      return;
    }
    const id = setTimeout(() => setDelayed(true), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return delayed;
}
